<template>
  <send-modal
    :title="title || $tr('responses.sendMessage.title')"
    :change-display="changeDisplay"
    :selected-responses-ids="selectedResponsesIds"
    :selected-responses="selectedResponses"
    :responses="responses"
    :email-template="emailTemplate"
    :email-status="emailStatus"
    :create-send-data="createSendData"
    :initial-body="signature"
    :is-success="isSuccess"
    :is-group="isGroup"
    :api-method="apiMethod"
    @submit="$emit('submit')"
  />
</template>

<script>
import SendModal from './SendAbstract.vue';

export default {
  name: 'SendMessageModal',

  components: {
    SendModal
  },

  props: {
    changeDisplay: Function,

    responses: {
      type: Array,
      default: () => []
    },

    selectedResponsesIds: {
      type: Array,
      default: () => []
    },

    selectedResponses: {
      type: Array,
      default: () => []
    },

    emailTemplate: {
      type: Object,
      default: () => {}
    },

    emailStatus: {
      type: Number,
      default: 0
    },

    isLinkShareShown: Boolean,
    isSuccess: Boolean,
    isGroup: Boolean,

    apiMethod: {
      type: String,
      default: 'sendMessage'
    },

    title: {
      type: String,
      default: ''
    }
  },

  computed: {
    signature() {
      return '\n\n\n' + this.$tr('responses.shareLink.signature') + ', ' + this.$store.state.user.data.name;
    }
  },

  methods: {
    createSendData(component) {
      return {
        emails: component.recipientsExtended.map(recipient => {
          if (recipient.candidate) {
            const data = {
              subject: component.subject,
              body: component.body,
              email: recipient.candidate.email
            };

            data.response = { id: recipient.id };

            return data;
          } else {
            const recipientWithCandidate = component.recipientsExtended.find(item => !!item.candidate);
            const data = {
              subject: component.subject,
              body: component.body,
              email: recipient.email
            };

            if (recipientWithCandidate) {
              data.response = { id: recipientWithCandidate.id };
            }

            return data;
          }
        })
      };
    }
  }
};
</script>
